import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="logo">
              <span className="logo-icon">◆</span>
              <span className="logo-text">Tem<span>pes</span></span>
            </div>
            <p className="footer-tagline">The Future of AI-Powered Crypto</p>
          </div>
          <div className="footer-links">
            <a href="#home">Home</a>
            <a href="#documents">Documents</a>
            <a href="#tokenomics">Tokenomics</a>
            <a href="#media">Media</a>
          </div>
          <div className="footer-social">
            <a href="#twitter" aria-label="Twitter"><i className="fa-brands fa-twitter"></i></a>
            <a href="#telegram" aria-label="Telegram"><i className="fa-brands fa-telegram"></i></a>
            <a href="#discord" aria-label="Discord"><i className="fa-brands fa-discord"></i></a>
            <a href="#github" aria-label="GitHub"><i className="fa-brands fa-github"></i></a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Tempes (BGG). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
